import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MotesProfileComponent } from './motes-profile.component';
import { LightImageModule } from '../light-image/light-image.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { UploadMediaModule } from '../upload-media/upload-media.module';
import { ClickOutsideDirectiveModule } from '../../directives';
import { MotesToggleModule } from '../motes-toggle/motes-toggle.module';
import { DeleteButtonModule } from '../delete-button/delete-button.module';
import { LoadingComponentModule } from '../loading/loading.module';
import { SimpleModalModule } from '../simple-modal/simple-modal.module';

@NgModule({
    declarations: [MotesProfileComponent],
    imports: [
        CommonModule,
        LightImageModule,
        SvgIconModule,
        FormsModule,
        UploadMediaModule,
        SvgIconModule,
        ClickOutsideDirectiveModule,
        MotesToggleModule,
        DeleteButtonModule,
        LoadingComponentModule,
        SimpleModalModule
    ],
    exports: [MotesProfileComponent]
})
export class MotesProfileModule { }
